import PropTypes from 'prop-types';
import React from 'react';

import './MenuTabs.scss';

export default class MenuTabs extends React.PureComponent {
    static propTypes = {
        /**
         * array of tab items to be rendered
         */
        tabItems: PropTypes.arrayOf(
            PropTypes.shape({
                /**
                 * string of text for tab item
                 */
                text: PropTypes.string.isRequired,
                /**
                 * function handler for clicking item
                 */
                onClick: PropTypes.func.isRequired,
                /**
                 * boolean whether item is the selected tab
                 */
                isSelected: PropTypes.bool,
                /**
                 * number of count
                 */
                count: PropTypes.oneOfType([
                    PropTypes.number,
                    PropTypes.string,
                ]),
                /**
                 * boolean to show count or not
                 */
                shouldShowCount: PropTypes.bool,
            })
        ).isRequired,
    };

    static defaultProps = {
        tabItems: [],
        shouldShowCount: false,
        count: 0,
    };

    renderTab = (tab, index) => {
        const isSelectedCss = tab.isSelected ? 'selected' : '';
        return (
            <React.Fragment key={`tab-${index}`}>
                <button
                    className={`tab-item ${isSelectedCss}`}
                    type="button"
                    onClick={tab.onClick}
                >
                    {tab.text}&nbsp;
                    {tab.shouldShowCount ? `(${tab.count})` : null}
                </button>
                {index !== this.props.tabItems.length - 1 ? (
                    <span className="divider">|</span>
                ) : null}
            </React.Fragment>
        );
    };

    render() {
        return (
            <div className="component-Elements-MenuTabs">
                {this.props.tabItems.map(this.renderTab)}
            </div>
        );
    }
}
